import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Announcement from "./Announcement";

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[#171717] text-[#DDD4B2]">
    <Announcement />
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export default Layout;
